import { t } from 'i18next';

/**
 * usePaymentSourceCountMessage
 *
 * A custom React hook that returns a label based on the number of selected payment sources.
 * The label adapts between singular and plural forms depending on the `count`.
 * When `count` is 0, it still uses the singular form (e.g., "Payment source") for better UX.
 *
 * This is useful for displaying dynamic, localized UI text that reflects selection count,
 * using a provided `paymentSource` object containing correct word forms.
 *
 * @param count - The number of selected payment sources (0 or more)
 * @param paymentSource - An object that holds the singular and plural forms of the label
 *
 * @returns A string label appropriate for the given count.
 */

function usePaymentSourceCountMessage() {
  return (count: number): string => {
    const paymentSource = t('statisticPage.header.filter.paymentSource', {
      returnObjects: true,
    }) as any;

    const label =
      count === 0 || count === 1
        ? (paymentSource?.nominative?.singular ?? '')
        : (paymentSource?.nominative?.plural ?? '');

    return `${label}`;
  };
}

export default usePaymentSourceCountMessage;
